export default {"src":"/_next/static/media/icon_nav_dd_tech_overview_on.99ddc00f.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};